module.exports = __webpack_public_path__ + "static/img/discount-details.1d99882.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/newHome/discount-details.png
// module id = ONgy
// module chunks = 1